'use strict';

import angular from 'angular';

export default angular.module('syncplicityLoginApp.constants', [])
  .constant('privateDocConfig', require('../../server/config/environment/privateDocumentation/privateDocumentationShared'))
  .constant('publicDocConfig', require('../../server/config/environment/publicDocumentation/publicDocumentationShared'))
  .name;



// WEBPACK FOOTER //
// ./client/app/app.constants.js